import React from "react";
import FacebookLogin, {type ReactFacebookLoginInfo} from "react-facebook-login";
import cn from "classnames";

import {Button} from "@pg-design/button-module";
import {SystemModal} from "@pg-design/modal-module";

import type {IFacebookResponse} from "../../types/IFacebookResponse";

interface IProps {
    appId: string;
    buttonText?: string;
    callback: (userInfo: ReactFacebookLoginInfo) => void;
    className?: string;
    onClick?: () => void;
}

interface IState {
    showEmailIsRequiredModal: boolean;
    loaderState: boolean;
}

/*
 *  This most probably will not authenticate user on localhost that does not use https.
 *  Even though documentation states https is not required in localhost, setting "Enforce https" is turned off and
 *  valid oAuth redirects are http it still does not work. I have tried multiple workarounds to make this work
 *  with no luck. Facebook setting page is buggy, inconsistent and have vague, unexplicit quirks. This may have
 *  something to do with 'rp.' or 'rpm.' before localhost or that we are using different ports for the same domain.
 *  The fastest way I found to test it is on staging.
 */
export class FacebookAuth extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showEmailIsRequiredModal: false,
            loaderState: false
        };
    }

    private uniqueFbId = "unique_fb_auth_id_294171931";

    private displayEmailIsRequiredModalOrProceedWithSocialAuth = (response: IFacebookResponse) => {
        if (response.accessToken) {
            if (response.email) {
                this.closeModal();
                this.props.callback(response);
            } else {
                this.setState({loaderState: false});
                this.openModal();
            }
        } else {
            this.setState({loaderState: false});
            this.closeModal();
        }
    };

    private clickFacebookButton = () => {
        this.setState({loaderState: true});
        (document.getElementsByClassName(this.uniqueFbId)[0] as HTMLElement).click();
    };

    private openModal = () => this.setState({showEmailIsRequiredModal: true});
    private closeModal = () => this.setState({showEmailIsRequiredModal: false});

    public render() {
        return (
            <>
                <SystemModal isOpen={this.state.showEmailIsRequiredModal} onModalClose={this.closeModal} className="modal-application-form fb-login-modal">
                    <div className="bgc-white p-xxxl">
                        <h2 className="fs22 fwl tac mv-lg lh1-3">
                            Aby móc utworzyć dla Ciebie Twoją strefę na naszym portalu, potrzebny jest adres email do weryfikacji.
                        </h2>

                        <Button variant="filled_primary" className="w100 mv-md" type="submit" onClick={this.clickFacebookButton}>
                            Zaloguj się
                        </Button>

                        <div className="df fs14">
                            <div className="c-link pt-md fg-1 tal">
                                <span onClick={this.closeModal} className="curp">
                                    {/*<Icon icon="back" className="pr-sm" /> Powrót*/}
                                </span>
                            </div>
                        </div>
                    </div>
                </SystemModal>

                <FacebookLogin
                    appId={this.props.appId}
                    disableMobileRedirect
                    autoLoad={false}
                    fields="name,email,picture"
                    scope="public_profile,email"
                    callback={this.displayEmailIsRequiredModalOrProceedWithSocialAuth}
                    //FacebookLogin has no props for id, therefore i pass unique identifier to it's cssClass
                    cssClass={cn(this.uniqueFbId, this.props.className)}
                    textButton={this.props.buttonText ? this.props.buttonText : "Zaloguj się z Facebook"}
                    //If someone has declined a permission for app, the login dialog won't let us re-request the permission unless we pass auth_type=rerequest along with our request.
                    authType="rerequest"
                    onFailure={this.closeModal}
                    onClick={this.props.onClick}
                />
            </>
        );
    }
}
import React from "react";
import FacebookLogin, {type ReactFacebookLoginInfo} from "react-facebook-login";
import cn from "classnames";

import {Button} from "@pg-design/button-module";
import {SystemModal} from "@pg-design/modal-module";

import type {IFacebookResponse} from "../../types/IFacebookResponse";

interface IProps {
    appId: string;
    buttonText?: string;
    callback: (userInfo: ReactFacebookLoginInfo) => void;
    className?: string;
    onClick?: () => void;
}

interface IState {
    showEmailIsRequiredModal: boolean;
    loaderState: boolean;
}

/*
 *  This most probably will not authenticate user on localhost that does not use https.
 *  Even though documentation states https is not required in localhost, setting "Enforce https" is turned off and
 *  valid oAuth redirects are http it still does not work. I have tried multiple workarounds to make this work
 *  with no luck. Facebook setting page is buggy, inconsistent and have vague, unexplicit quirks. This may have
 *  something to do with 'rp.' or 'rpm.' before localhost or that we are using different ports for the same domain.
 *  The fastest way I found to test it is on staging.
 */
export class FacebookAuth extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showEmailIsRequiredModal: false,
            loaderState: false
        };
    }

    private uniqueFbId = "unique_fb_auth_id_294171931";

    private displayEmailIsRequiredModalOrProceedWithSocialAuth = (response: IFacebookResponse) => {
        if (response.accessToken) {
            if (response.email) {
                this.closeModal();
                this.props.callback(response);
            } else {
                this.setState({loaderState: false});
                this.openModal();
            }
        } else {
            this.setState({loaderState: false});
            this.closeModal();
        }
    };

    private clickFacebookButton = () => {
        this.setState({loaderState: true});
        (document.getElementsByClassName(this.uniqueFbId)[0] as HTMLElement).click();
    };

    private openModal = () => this.setState({showEmailIsRequiredModal: true});
    private closeModal = () => this.setState({showEmailIsRequiredModal: false});

    public render() {
        return (
            <>
                <SystemModal isOpen={this.state.showEmailIsRequiredModal} onModalClose={this.closeModal} className="modal-application-form fb-login-modal">
                    <div className="bgc-white p-xxxl">
                        <h2 className="fs22 fwl tac mv-lg lh1-3">
                            Aby móc utworzyć dla Ciebie Twoją strefę na naszym portalu, potrzebny jest adres email do weryfikacji.
                        </h2>

                        <Button variant="filled_primary" className="w100 mv-md" type="submit" onClick={this.clickFacebookButton}>
                            Zaloguj się
                        </Button>

                        <div className="df fs14">
                            <div className="c-link pt-md fg-1 tal">
                                <span onClick={this.closeModal} className="curp">
                                    {/*<Icon icon="back" className="pr-sm" /> Powrót*/}
                                </span>
                            </div>
                        </div>
                    </div>
                </SystemModal>

                <FacebookLogin
                    appId={this.props.appId}
                    disableMobileRedirect
                    autoLoad={false}
                    fields="name,email,picture"
                    scope="public_profile,email"
                    callback={this.displayEmailIsRequiredModalOrProceedWithSocialAuth}
                    //FacebookLogin has no props for id, therefore i pass unique identifier to it's cssClass
                    cssClass={cn(this.uniqueFbId, this.props.className)}
                    textButton={this.props.buttonText ? this.props.buttonText : "Zaloguj się z Facebook"}
                    //If someone has declined a permission for app, the login dialog won't let us re-request the permission unless we pass auth_type=rerequest along with our request.
                    authType="rerequest"
                    onFailure={this.closeModal}
                    onClick={this.props.onClick}
                />
            </>
        );
    }
}
